import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

export default class YesNoCell extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field || this.props.rowType !== 'data') return null;

    return (
      <td {...this.props.tdProps}>
        {this.props.dataItem[this.props.field] === null ? 'Unknown' : this.props.dataItem[this.props.field] ? 'Yes' : 'No'}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return this.props.dataItem[this.props.field] !== nextProps.dataItem[this.props.field];
  }
}
